"use client";
import Script from "next/script";
import { GoogleTagManager, GoogleAnalytics } from "@next/third-parties/google";
import { store } from "@/redux/store";
import { Provider } from "react-redux";
import HeaderNavigation from "@/components/HeaderNavigation";
import SnackBar from "@/components/SnackBar";
import Footer from "@/components/Footer";
import GlobalPopup from "@/components/GlobalPopup";
import { Suspense, useEffect } from "react";
import CapturePageHit from "@/components/CapturePageHit";
import "../src/styles/base/global.scss";
import { usePathname } from "next/navigation";
import { sendAnalytics } from "@/utils/helpers/analytics";
import { SpeedInsights } from '@vercel/speed-insights/next';

function RootLayout({ children }) {
  const pathname = usePathname();
  const hideSiteChrome = pathname === "/hindi-ev-promo" || pathname === "/";
  useEffect(() => {
      sendAnalytics("screen_view", { page_url: pathname });
  }, [pathname]);

  return (
    <Provider store={store}>
      <html lang="en">
        <head>
          <title>
            Innovolt Club | Second Hand Electric Vehicles | Used Electric Gadi
          </title>
          <meta
            name="description"
            content="Buy an Electric load gadi from Brands like Piaggio, Mahindra, ETrio, Altigreen, OSM . Get commercial vehicle details such as features and prices in India."
          />
          <meta
            name="keywords"
            content="Innovolt, EV, EVs, electric auto, ev in india, electric auto rickshaw, auto gadi, auto, auto rickshaw, auto india, Light Commercial Vehicle, commercial vehicle, small commercial vehicles"
          />
          <meta
            name="description"
            content='Used commercial electric vehicles (EVs) at "Innovolt.club", India&apos;s leading EV marketplace. Find us in Bangalore, Hyderabad, Delhi, Pune, and Chennai. Experience the ease and savings of sustainable transportation solutions tailored to your business needs.'
          />
          <link rel="canonical" href="https://www.innovolt.in" />
          <meta
            property="og:title"
            content="Innovolt Club | Second Hand Electric Vehicles | Used  Electric Gadi"
          />
          <meta
            property="og:description"
            content='Used commercial electric vehicles (EVs) at "Innovolt.club", India&apos;s leading EV marketplace. Find us in Bangalore, Hyderabad, Delhi, Pune, and Chennai. Experience the ease and savings of sustainable transportation solutions tailored to your business needs.'
          />
          <meta name="author" content="Innovolt" />
          <meta name="url" content="innovolt" />
          <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
          <meta name="lang" content="en" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
          <link rel="icon" href="/favicon.png" />
        </head>
        <GoogleTagManager gtmId="GTM-TNQX4HX3" />
        <Suspense>
          <CapturePageHit />
        </Suspense>
        <body style={{ margin: 0 }}>
          {!hideSiteChrome && <HeaderNavigation />}
          {children}
          <SpeedInsights />
          <GlobalPopup />
          {!hideSiteChrome && <Footer />}
          <SnackBar />
          <Script id="microsoft-clarity" strategy="afterInteractive">
            {`(function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "w3ox7m3yjf");`}
          </Script>
        </body>
        <GoogleAnalytics gaId="G-SZXX4RYZJR" />
      </html>
    </Provider>
  );
}

export default RootLayout;
